import React from 'react';
import { Checkbox, FormControlLabel, MenuItem, TextField } from '@material-ui/core';
import { useFormContext } from '../FormContext';
import ConfigFieldControl from './components/ConfigFieldControl';
import FormConfigRequired from './FormConfigRequired';
import FormConfigTitleDescription from './FormConfigTitleDescription';
const FormConfigSlider = () => {
    const { formState, setFormState, notifyFormEdit, entitySchema } = useFormContext();
    const element = formState.selectedFormElement;
    const column = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.find(column => column.name === element.dataSource);
    const isInteger = (column === null || column === void 0 ? void 0 : column.type) === 'integer' || (column === null || column === void 0 ? void 0 : column.type) === 'int';
    if (!element.config)
        element.config = {};
    const { config = {} } = element;
    const getParsedValue = (value) => {
        return isInteger ? parseInt(value) : parseFloat(value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, type: 'number', variant: 'outlined', label: 'Minimum value on slider', inputProps: { step: 'any' }, value: typeof (config === null || config === void 0 ? void 0 : config.min) !== 'undefined' ? config.min : '', onChange: event => {
                    const parsed = getParsedValue(event.target.value);
                    config.min = isFinite(parsed) ? Math.abs(parsed) : undefined;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, type: 'number', variant: 'outlined', label: 'Maximum value on slider', inputProps: { step: 'any' }, value: typeof (config === null || config === void 0 ? void 0 : config.max) !== 'undefined' ? config.max : '', onChange: event => {
                    const parsed = getParsedValue(event.target.value);
                    config.max = isFinite(parsed) ? Math.abs(parsed) : undefined;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, type: 'number', variant: 'outlined', label: 'Step increment on slider', inputProps: { step: 'any' }, value: typeof (config === null || config === void 0 ? void 0 : config.step) !== 'undefined' ? config.step : '', onChange: event => {
                    const parsed = getParsedValue(event.target.value);
                    config.step = isFinite(parsed) ? Math.abs(parsed) : undefined;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, type: 'number', variant: 'outlined', label: 'Default value', inputProps: { step: 'any' }, value: typeof (config === null || config === void 0 ? void 0 : config.defaultValue) !== 'undefined'
                    ? config.defaultValue
                    : '', onChange: event => {
                    const parsed = getParsedValue(event.target.value);
                    config.defaultValue = isFinite(parsed)
                        ? Math.abs(parsed)
                        : undefined;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Minimum Value Description', value: typeof (config === null || config === void 0 ? void 0 : config.minValueDescription) !== 'undefined'
                    ? config.minValueDescription
                    : '', onChange: event => {
                    config.minValueDescription = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Minimum Value Description', value: typeof (config === null || config === void 0 ? void 0 : config.maxValueDescription) !== 'undefined'
                    ? config.maxValueDescription
                    : '', onChange: event => {
                    config.maxValueDescription = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Show marks on slider', control: React.createElement(Checkbox, { color: 'primary', checked: element.config.marks, onChange: () => {
                        element.config.marks = !element.config.marks;
                        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                        notifyFormEdit();
                    } }) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', label: 'Orientation', value: (config === null || config === void 0 ? void 0 : config.orientation) || 'horizontal', onChange: event => {
                    config.orientation = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } },
                React.createElement(MenuItem, { value: 'horizontal' }, "Horizontal"),
                React.createElement(MenuItem, { value: 'vertical' }, "Vertical"))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', label: 'Value label display', value: (config === null || config === void 0 ? void 0 : config.valueLabelDisplay) || 'on', onChange: event => {
                    config.valueLabelDisplay = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } },
                React.createElement(MenuItem, { value: 'on' }, "Always on"),
                React.createElement(MenuItem, { value: 'auto' }, "Display while sliding"),
                React.createElement(MenuItem, { value: 'off' }, "Always off")))));
};
export default FormConfigSlider;
//# sourceMappingURL=FormConfigSlider.js.map